import styles from '../styles/Color.module.scss'
import { NextPage } from 'next';
import { Button, Card, Col, Row, Tooltip } from 'antd';
import React, { useState } from 'react';
import { Download, Like } from '@icon-park/react';
import {http} from '../../utils/api'
import { colorLike, getBgImg, getGradualPng } from '../../constants/api';
import { Item } from '../../@types/color';
import { domain, title } from '../../constants/heads';
type Props = {
    item: Item
    imgUrl: string | string[]
};
const Background: NextPage<Props> = ({ item, imgUrl}) => {
    const { like_status } = item
    const [likeStatus, setLikeStatus] = useState(like_status)
    const [like, setLike] = useState(item.like)
    const likeFun = async () => {
        let res:any = await http(colorLike, { id: item._id })
        if (res.code == 200) {
            if (res.data.num == 1) {
                setLike(like + 1)
                setLikeStatus(true)
            } else {
                setLike(like - 1)
                setLikeStatus(false)
            }
        }
    }
    const DownloadPng = async () => {
        let res = await http(getBgImg, { id: item._id })
        const a = document.createElement("a");
        a.href = res.data.url; //图片地址
        a.download = `${title}_${domain}_${new Date().getTime()}.png`; //图片名及格式
        document.body.appendChild(a);
        a.target = '_new';
        a.click();
    }

    return (
        <Card className={styles.background} bordered={false}>
            <a>
                <img src={imgUrl+item.img}/>
            </a>
            <Row style={{ paddingTop: '18px' }}>
                <Col span={12}>
                    <Button onClick={likeFun} shape="round" icon={<Like theme={likeStatus ? "filled" : "outline"} size="14" fill={likeStatus ? '#ffdf29' : "#d9d9d9"} />} size="small">
                        &nbsp; {like}
                    </Button>
                </Col>
                <Col span={12} style={{ textAlign: 'right' }}>
                    <Tooltip placement="top" title='下载PNG'> 
                        <Download onClick={() => { DownloadPng() }} theme="outline" size="20" fill="#999" strokeWidth={3} />
                    </Tooltip>
                </Col>
            </Row>
        </Card>
    )

}

export default Background